// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__gjyZ3","location":"Header_location__2YFOF"};